import * as api from 'services/api-service'

export type ProfilePage =
    'do-more'
  | 'posts'
  | 'profile'
  | 'settings'
export type ProfilePostTab =
    'reviews'
  | 'photos-videos'
  | 'questions'
  | 'answers'
  | 'checkout-comments'


interface IStoreState {
  currentProfilePage: ProfilePage
  profileStats?: api.UserUgcStats
  currentProfilePostTab?: ProfilePostTab
  dashboardIsOpen?: boolean
}

class ProfileStore {
  state: IStoreState = {
    currentProfilePage: 'posts',
    profileStats: {},
    currentProfilePostTab: 'reviews',
    dashboardIsOpen: false
  }
}

export default new ProfileStore()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/profile/profile-store.ts